import { Component, Input } from '@angular/core';
import { CompaniesStoreService } from 'src/app/core/store/services/companies-store.service';

@Component({
  selector: 'craft-company-info-dropdown',
  templateUrl: './craft-company-info-dropdown.component.html',
  styleUrls: ['./craft-company-info-dropdown.component.scss'],
  standalone: false,
})
export class CraftCompanyInfoDropdownComponent {
  @Input() public companyId: string | undefined | null;

  constructor(public companyStoreService: CompaniesStoreService) {}
}
